import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router';
import { useRouteMatch } from 'react-router-dom';
import PageLoader from '@jumbo/components/PageComponents/PageLoader';

const Summary = () => {
  const match = useRouteMatch();

  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route path={`${match.url}/overview`} component={lazy(() => import('./Overview'))} />
        <Route path={`${match.url}/factor`} component={lazy(() => import('./Factor'))} />
        <Route path={`${match.url}/car-model`} component={lazy(() => import('./CarModel'))} />

        <Route component={lazy(() => import('../../error/Error404'))} />
      </Switch>
    </Suspense>
  );
};

export default Summary;
